import React from "react"
import Link from "gatsby-link"
import Img from "gatsby-image"

import { Paper,} from "../../simple";

const Banner = ({ id, banner }) => (

    <Paper
        zDepth={2}
        raised={3}
        className="m-3 p-0 bg-dark d-flex flex-column justify-content-between">
        <Link to={`${id}/view`}>
            <Img sizes={banner.localFile.childImageSharp.sizes} />
        </Link>
    </Paper>
)


export default Banner


// WEBPACK FOOTER //
// ./src/components/simple/GameContent/index.js